import { ProblemDetails } from "areas/common/models/problemDetails";

export class PaygError extends Error {

    problemDetails: ProblemDetails;

    constructor(problemDetails: ProblemDetails) {
        super(problemDetails.title, { cause: problemDetails });

        // Maintains proper stack trace for where our error was thrown (only available on V8)
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, PaygError);
        }

        this.name = "PaygError";
        this.problemDetails = problemDetails;

        Object.setPrototypeOf(this, PaygError.prototype);
    }
}
